import { ThreePlPartner } from '../../domain/entities/partner-entity';
import { createPartner } from '../datasources/create-partner';
import { editPartner } from '../datasources/edit-partner';
import { getPartner } from '../datasources/get-partner';
import { getPartners } from '../datasources/get-partners';
import { PartnerRepository } from '../../domain/repositories/partner-repository';

export class PartnerRepositoryImpl implements PartnerRepository {
  async CreatePartner(name: string, hook: string): Promise<ThreePlPartner> {
    const result = await createPartner(name, hook);
    return new ThreePlPartner(result);
  }

  async EditPartner(id: string, name: string, hook: string): Promise<ThreePlPartner> {
    const result = await editPartner(id, name, hook);

    return new ThreePlPartner(result);
  }

  async GetPartner(id: string): Promise<ThreePlPartner> {
    const result = await getPartner(id);

    return new ThreePlPartner(result);
  }

  async GetPartners(): Promise<ThreePlPartner[]> {
    const partners = await getPartners();
    return partners.map((partner: any) => new ThreePlPartner(partner));
  }
}
